import React from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import validate from './validate';
import {modal} from 'react-redux-modal';
import {renderField} from '../../../utils/renderFields';
import {authAssociateUser} from '../../../actions/auth';
import ForgotPasswordComponent from '../../Modals/ForgotPassword';


class ConfirmAccountAssociationForm extends React.Component {
  constructor(props){
    super(props);
    this.submit = this.submit.bind(this);
    this.passwordReset = this.passwordReset.bind(this);
    this.submit = this.submit.bind(this);
  }

  passwordReset(e){
    e.preventDefault();
    this.props.removeModal();
    modal.add(ForgotPasswordComponent, {title:'', size:'medium', hideTitleBar:true})
  }

  submit(values){
    if (values.password) {
      return this.props.dispatch(authAssociateUser(this.props.email, values.password, this.props.removeModal));
    }
  }

  render(){
    const { error, handleSubmit, pristine, submitting, statusText, errors } = this.props;
    return(
      <form className="link-form" onSubmit={handleSubmit(this.submit)}>
        <div className="row no-gutters align-items-baseline">
          <div className="col-sm-7">
            <Field component={renderField} name="password" type="password" label="password" className="form-control" hiddenLabel />
          </div>
          <div className="col-sm-5">
            <a href="#" className="u-fontSize-11 forgot-password-text" onClick={this.passwordReset}><span>Forgot Password?</span></a>
          </div>
        </div>
        <div className="row">
          <div className="col button-wrap">
            <button className="btn btn-primary" type="submit" disabled={submitting}>Continue</button>
          </div>
        </div>
      </form>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    statusText: state.auth.statusText,
    status: state.auth.status,
    email: state.auth.email
  }
}
ConfirmAccountAssociationForm = reduxForm({form: 'confirmAssociation', validate, fields:['password']})(ConfirmAccountAssociationForm);
export default connect(mapStateToProps)(ConfirmAccountAssociationForm);
